import React from 'react';
import Firebase from 'firebase';
import Mapa from './mapa'


export default class bottom extends React.Component {
    constructor() {
        super();
        this.state = {
        }
    }

    setData(obj, option) {
        const contex = this;
        var local = this.state.local ? this.state.local : {};
        Object.keys(Object.values(obj)[0]).map((o, index) => {
            var tt = o.substring(o.indexOf("_") + 1);
            if (tt === option) {
                local[option] = Object.values(Object.values(obj)[0])[index]
                contex.setState({ local: local });
                return local;
            }
        })
    }


    componentWillReceiveProps(nextProps) {
        const contex = this;
        if (nextProps.datos) {
            nextProps.datos.map((d) => {
                if (d.results.marcaje === "check-in") {
                    this.setState({ checkIn: d })
                } if (d.results.marcaje === "check-out") {
                    this.setState({ checkOut: d })
                } if (d.results.local) {
                    var gps_store = {};
                    var storeRef = Firebase.database().ref("stores/" + localStorage.client_id).orderByChild("0000_codloc").equalTo(d.results.local).once("value").then(resp => {
                        contex.setData(resp.val(), "local");
                        contex.setData(resp.val(), "Lat");
                        contex.setData(resp.val(), "Long");
                    })
                }
            })
        }
    }


    dregreesToRadian(deg) {
        return deg * Math.PI / 180;
    };


    componentWillUpdate(nextProps, nextState) {
        if (nextState.checkIn !== this.state.checkIn && nextState.checkOut !== this.state.checkOut) {
            var R = 6371e3; // metres
            var φ1 = this.dregreesToRadian(nextState.checkIn.global.gps.lat);
            var φ2 = this.dregreesToRadian(nextState.checkOut.global.gps.lat);
            var Δφ = this.dregreesToRadian((nextState.checkOut.global.gps.lat - nextState.checkIn.global.gps.lat));
            var Δλ = this.dregreesToRadian((nextState.checkOut.global.gps.lon - nextState.checkIn.global.gps.lon));

            var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                Math.cos(φ1) * Math.cos(φ2) *
                Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            var d = R * c;
            this.setState({ d1: d })
        }

    }

    renderDistanceA() {
        if (this.state.local) {
            if (this.state.local.Lat && this.state.local.Long) {
                var R = 6371e3; // metres
                var φ1 = this.dregreesToRadian(this.state.checkIn.global.gps.lat);
                var φ2 = this.dregreesToRadian(this.state.local.Lat);
                var Δφ = this.dregreesToRadian((this.state.local.Lat - this.state.checkIn.global.gps.lat));
                var Δλ = this.dregreesToRadian((this.state.local.Long - this.state.checkIn.global.gps.lon));

                var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                    Math.cos(φ1) * Math.cos(φ2) *
                    Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

                var d = R * c;
                return (
                    <li>{"Distancia entre el punto de entrada y el local " + this.state.local.local + " es de " + parseInt(d) + " metros."}</li>
                )
            }
        }
    }

    renderDistanceB() {
        if (this.state.local) {
            if (this.state.local.Lat && this.state.local.Long) {
                var R = 6371e3; // metres
                var φ1 = this.dregreesToRadian(this.state.checkOut.global.gps.lat);
                var φ2 = this.dregreesToRadian(this.state.local.Lat);
                var Δφ = this.dregreesToRadian((this.state.local.Lat - this.state.checkOut.global.gps.lat));
                var Δλ = this.dregreesToRadian((this.state.local.Long - this.state.checkOut.global.gps.lon));

                var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                    Math.cos(φ1) * Math.cos(φ2) *
                    Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

                var d = R * c;
                return (
                    <li>{"Distancia entre el punto de salida y el local " + this.state.local.local + " es de " + parseInt(d) + " metros."}</li>
                )
            }
        }
    }


    render() {
        return (
            <div className="form-group row" style={{ width: "100%" }}>
                <div style={{ width: "50%" }}>
                    <Mapa checkIn={this.state.checkIn} checkOut={this.state.checkOut} local={this.state.local} />
                </div>
                <div style={{ width: "50%", padding: "10px" }}>
                    <div style={{ border: "1px solid #ccc", height: "260px", padding: "10px" }}>
                        <ul>
                            {
                                this.state.d1 ?
                                    <li>{"Distancia entre el punto de entrada y punto de salida es de " + parseInt(this.state.d1) + " metros."}</li>
                                    :
                                    ""
                            }
                            {
                                this.renderDistanceA()
                            }
                            {
                                this.renderDistanceB()
                            }
                        </ul>
                    </div>
                </div>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/control_de_asistencia/bottom.js